import React from 'react'
import TypographyContainer from "app/react/components/typography/TypographyContainer";
import TypographyContent from "app/react/components/typography/TypographyContent";

export default function TypographyOverview (props) {
  return (
    <TypographyContainer {...props}>
      <TypographyContent/>
    </TypographyContainer>
  )
}